import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { ColumnSchema } from './schemaApi';

type TableColumnsResponse = {
  columns: ColumnSchema[];
};

export const fetchTableColumnsCount = async (tableFqn: string, includeDeleted: boolean = false): Promise<number> => {
  const response = await openMetadataApiClient.get<TableColumnsResponse>(
    `/tables/name/${encodeURIComponent(tableFqn)}`,
    {
      params: {
        fields: 'columns',
        include: includeDeleted ? 'deleted' : 'non-deleted',
      },
    }
  );

  return response.data.columns?.length || 0;
};
